import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import { createForemanApiKey, deleteForemanApiKey, getForemanApiKey } from '@/services/core/foreman-api-keys'
import type { IForemanApiKeyForm } from '@/types/core/forms'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

export const useForemanApiKeys = () => {
  const client = useQueryClient()

  const getApiKeyQuery = () =>
    useQuery({
      queryKey: ['foreman-api-key'],
      queryFn: () => getForemanApiKey(),
    })

  const createApiKeyMutation = useMutation({
    mutationFn: (form: IForemanApiKeyForm) => createForemanApiKey(form),
    onError: NotifyErrorWrapper('Failed to create API key'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['foreman-api-key'] })
      NotifySuccess(`API key created successfully`)
    },
  })

  const deleteApiKeyMutation = useMutation({
    mutationFn: (id: number) => deleteForemanApiKey(id),
    onError: NotifyErrorWrapper('Failed to delete API key'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['foreman-api-key'] })
      NotifySuccess(`API key deleted successfully`)
    },
  })

  return {
    getApiKeyQuery,
    createApiKeyMutation,
    deleteApiKeyMutation,
  }
}
